import { useState } from "react";

/**
 * Per-channel gallery view state (step 5.2c): selection mode, the per-image
 * selection set, the "load more" visible count, and per-URL image-loaded flags
 * — all keyed by fully-qualified channel id (image-loaded is keyed by URL).
 *
 * Pure UI state: no effects, no loaders, no inputs. Consumed only by the gallery
 * JSX in ChatLayout, which reads the returned maps and calls the setters.
 */
export function useGalleryView() {
  const [galSelModeByChan, setGalSelModeByChan] = useState<Record<string, boolean>>({});
  const [galSelectedByChan, setGalSelectedByChan] = useState<Record<string, Record<string, boolean>>>({});
  const [galVisibleCountByChan, setGalVisibleCountByChan] = useState<Record<string, number>>({});
  const [imgLoadedByUrl, setImgLoadedByUrl] = useState<Record<string, boolean>>({});

  return {
    galSelModeByChan,
    setGalSelModeByChan,
    galSelectedByChan,
    setGalSelectedByChan,
    galVisibleCountByChan,
    setGalVisibleCountByChan,
    imgLoadedByUrl,
    setImgLoadedByUrl,
  };
}
